const notificationlogs = {
	title: "Notification history",
	type: "Type",
	slug: "Slug",
	subject: "Email subject / SMS message",
	message: "Message",
	recipient: "Recipient",
	date_sent: "Date sent",
	status: "Status",
	sender: "Sender",
	system_triggered: "System triggered",
};
export default notificationlogs;